<button mat-button class="inline-action-button" (click)="$event.stopPropagation()">{{ label() }}</button>
